import React, { FC } from 'react'
type IconProps = {
  className?: string
  size?: number
}
export const LinkedInIcon: FC<IconProps> = ({ className, size }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 24 24'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M19.2001 3.60001C19.8376 3.60001 20.4001 4.16251 20.4001 4.83751V19.2C20.4001 19.875 19.8376 20.4 19.2001 20.4H4.7626C4.1251 20.4 3.6001 19.875 3.6001 19.2V4.83751C3.6001 4.16251 4.1251 3.60001 4.7626 3.60001H19.2001ZM8.6626 18V10.0125H6.1876V18H8.6626ZM7.4251 8.88751C8.2126 8.88751 8.8501 8.25001 8.8501 7.46251C8.8501 6.67501 8.2126 6.00001 7.4251 6.00001C6.6001 6.00001 5.9626 6.67501 5.9626 7.46251C5.9626 8.25001 6.6001 8.88751 7.4251 8.88751ZM18.0001 18V13.6125C18.0001 11.475 17.5126 9.78751 15.0001 9.78751C13.8001 9.78751 12.9751 10.4625 12.6376 11.1H12.6001V10.0125H10.2376V18H12.7126V14.0625C12.7126 13.0125 12.9001 12 14.2126 12C15.4876 12 15.4876 13.2 15.4876 14.1V18H18.0001Z'
        }
        fill={'#262626'}
      />
    </svg>
  )
}
